export function cssStyle(theme) {

    const drawerWidth = 240;

    return {
        root: {
            display: "flex",
            '&$focused$notchedOutline': {
                borderColor: 'orange'
            }

        },
        toolbar: {
            paddingRight: 24, // keep right padding when drawer closed
        },
        toolbarIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px",
            ...theme.mixins.toolbar,
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        menuButtonHidden: {
            display: "none",
        },
        title: {
            flexGrow: 1,
        },
        drawerPaper: {
            position: "relative",
            whiteSpace: "nowrap",
            width: drawerWidth,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerPaperClose: {
            overflowX: "hidden",
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            width: theme.spacing(7),
            [theme.breakpoints.up("sm")]: {
                width: theme.spacing(9),
            },
        },
        appBarSpacer: theme.mixins.toolbar,
        content: {
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        paper: {
            padding: theme.spacing(2),
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
        },
        fixedHeight: {
            height: 240,
        },
        testPedro: {
            display: "flex",
            alignItems: "center"
        },
        formwrapper: {
            width: "100%",
        },
    }
}

export const COLORS = {
    primary: "#FADD00",
    danger: "#b80d0d",
    yellow: "#FFFB92",
    lightYellow: "#fff68f",
    lightGrey: "#ffffff80",
    dark: "#060606",
    black61: "#0000009c",
    green: "#28d835",
    green2: "#0f9919",
    grey: "#424242",
    darkGrey: "#2b2a2a",
    white: "#ffffff"
}

export const MESSAGE_TYPES = {
    MANUFACTURER_CREATE: "Fornecedor criado com sucesso",
    MANUFACTURER_CREATE_ERROR: "Falha ao criar o Fornecedor",
    MANUFACTURER_SEARCH: "Fornecedor encontrado com sucesso",
    MANUFACTURER_SEARCH_ERROR: "Falha ao pesquisar o Fornecedor",
    MANUFACTURER_UPDATE: "Fornecedor atualizado com sucesso",
    MANUFACTURER_UPDATE_ERROR: "Falha ao editar o Fornecedor",

    LOGIN_ERROR: "Falha ao realizar login",
    LOGIN_SUCCESS: "Login realizado com sucesso",
    LOGOUT_ERROR: "Falha ao realizar logout",
    LOGOUT_SUCCESS: "Logout realizado com sucesso",

    PRODUCT_ALL_SUCCESS: "Todos os produtos recuperados",
    PRODUCT_CREATED: "Produto criado",
    PRODUCT_DELETE: "Produto deletado",
    PRODUCT_DELETE_ERROR: "Erro ao deletar o produto",
    PRODUCT_ERROR: "Algo deu errado",
    PRODUCT_IMAGE_UPLOAD: "Upload finalizado com sucesso",
    PRODUCT_IMAGE_UPLOAD_FAILURE: "Erro ao carregar imagem do produto",
    PRODUCT_NOT_FOUND: "Produto não encontrado",
    PRODUCT_SUCCESS: "Produto encontrado",
    PRODUCT_UPDATE: "Produto atualizado",

    USER_CREATED: "Usuário criado com sucesso",
    USER_CREATED_ERROR: "Erro ao criar usuário",
    USER_REMOVED: "Usuário removido com sucesso",
    USER_PASSWORD_RESET: "Senha resetada com sucesso!",
    USER_PASSWORD_RESET_ERROR: "Erro ao resetar a senha",
    USER_REMOVED__ERROR: "Erro ao remover usuário",
    USER_RETRIEVED: "Usuários recuperados com sucesso",
    USER_RETRIEVED_ERROR: "Erro ao recuperar usuários",
}

export const SORTING_TYPES = {
    NOME: "Nome",
    ESTOQUE_BAIXO: "Estoque baixo",
    ESTOQUE_ALTO: "Estoque alto",
    PRECO_BAIXO: "Preço baixo",
    PRECO_ALTO: "Preço alto"
}

export const PRODUCT_FIELDS = {
    CODE_FIELD: "codigo",
    NAME_FIELD: "nome"
}

export const ADMIN_UID = "aS19X4sNmSYtPxw9e7i2j5tCdZl1";

export const FUNCTIONS_URL = "https://us-central1-alvandir-gold-maquinas.cloudfunctions.net";
